import {isInView} from 'isinview';

if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      
      this.url = this.dataset.url;
      if (!this.url) return;

      if (this.url.includes('complementary')) {
        this.fetchRecommendations();
      } else {
        isInView(this, (target) => {
          this.fetchRecommendations();
        }, {
          once: true,
          threshold: 0.02,
        });
      }      

    }

    fetchRecommendations() {
      fetch(this.url)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');

          const container = sectionInnerHTML.querySelector(
            '.product-recommendations__container'
          );
          
          if (container) {
            this.innerHTML = container.outerHTML;

            const parentComplementaryContainer = this.closest('.product-complementary__container');
            if (parentComplementaryContainer) {
              parentComplementaryContainer.classList.remove('hidden');
            }
          }
          
        })
        .catch(e => {
          console.error(e);
        });

    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
